import React, { FC, useMemo } from 'react';

import { DailyUniqueIssuesData } from 'src/apps/dashboard/services/queries/dashboard/helpers/transformResults';

import { AccessibilityCriticalIssuesChart } from './AccessibilityCriticalIssuesChart';
import { CriticalIssuesData } from './types';

interface AccessibilityCriticalIssuesChartContainerProps {
	data?: DailyUniqueIssuesData[];
	uniqueIssuesData?: DailyUniqueIssuesData[];
	isLoading: boolean;
	error?: Error | null;
}

export const AccessibilityCriticalIssuesChartContainer: FC<
	AccessibilityCriticalIssuesChartContainerProps
> = ({ data, uniqueIssuesData, isLoading, error }) => {
	// Transform DailyUniqueIssuesData[] to CriticalIssuesData[] format expected by the chart
	const chartData = useMemo((): CriticalIssuesData[] | null => {
		if (!data || data.length === 0) {
			return null;
		}

		return data.map((item) => ({
			date: item.date,
			critical: item.critical,
			serious: item.serious,
			total: item.total
		}));
	}, [data]);

	return (
		<AccessibilityCriticalIssuesChart
			data={chartData}
			uniqueIssuesData={uniqueIssuesData}
			isLoading={isLoading}
			error={error ? 'Failed to load critical issues data' : null}
		/>
	);
};
